<script>
  export let id = "";
  export let key = "";
  export let label = "";
  export let value = false;
  export let disabled = false;
  export let handleChange = (e) => {
    value = e.target.checked;
  };
</script>

{#if label}
  <div>
    <label for={key} style="margin-bottom: 15px;">{label}</label>
  </div>
{/if}
<input
  type="checkbox"
  id={`checkbox-${id}-${key}`}
  bind:checked={value}
  on:change={handleChange}
  class="bx--checkbox"
  {disabled}
/>
<label
  for={`checkbox-${id}-${key}`}
  class="bx--checkbox-label"
  style="width: 20px;"
/>

<style>
  label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    font-weight: 700;
    color: #1f2937;
  }
</style>
